<template>
  <div>
    <div ref="scrollbar" class="page_main_height">
      <div class="recruit">
        <!--大屏显示-->
        <div class="big_screen">
          <div class="w-full" style="height: 5rem" />

          <div class="main text">
            <!--标题-->
            <div class="flex justify-center mb-12 mt-3">
              <h2 class="text-xl font-bold text-primary">全部职位</h2>
            </div>

            <div class="table">
              <div class="table_head">
                <div class="select text">
                  <el-col :span="2" class="head_title text">搜索职位：</el-col>
                  <el-col :span="22">
                    <el-input v-model="select.like" placeholder="搜索关键词" maxlength="60%" size="small" class="select_input" />
                    <el-button size="mini" class="select_button" @click="select_recruit">搜索</el-button>
                  </el-col>
                </div>
                <div>
                  <el-col :span="2" class="head_title">工作区域：</el-col>
                  <el-col :span="21">
                    <span v-for="(a, i) in addr" :key="i">
                      <span ref="addr_tag" :class="i === 0 ? 'tag selected' : 'tag'" @click="get_addr_class(a, i)">{{ a }}</span>
                      <span v-if="i < addr.length - 1">|</span>
                    </span>
                  </el-col>
                </div>
                <div>
                  <el-col :span="2" class="head_title">工作类型：</el-col>
                  <el-col :span="22">
                    <template v-for="(t, i) in type">
                      <span :key="i">
                        <span ref="type_tag" :class="i === 0 ? 'tag selected' : 'tag'" @click="get_type_class(t, i)">{{ t }}</span>
                        <span v-if="i < type.length - 1">|</span>
                      </span>
                    </template>
                  </el-col>
                </div>
              </div>

              <div class="table_main">
                <el-table :data="tableData" style="width: 100%" class="text" @row-click="show">
                  <template slot-scope="scope">
                    <el-table-column prop="n" label="职位名称" min-width="180" />
                    <el-table-column align="center" prop="t" label="职位类型" min-width="100" />
                    <el-table-column align="center" prop="a" label="工作区域" min-width="100" />
                    <el-table-column align="center" label="操作" min-width="100">
                      <el-button size="mini" type="primary" @click="show(scope.row)">查看详情</el-button>
                    </el-table-column>
                  </template>
                </el-table>
                <el-pagination background layout="prev, pager, next" :total="select.total" :page-size="select.ps" class="recruit_pagination" :current-page.sync="select.pageNum" @current-change="select_recruit()" />
              </div>
            </div>

            <el-drawer title="职位详情" :visible.sync="drawers.drawer" :direction="drawers.d" :modal="drawers.m" class="text_center drawer_title">
              <div class="text_left recruit_info">
                <div class="info_head">职位内容：</div>
                <template v-for="(d, i) in drawers.info.wc">
                  <div :key="i">
                    <span>{{ (++i) + '、' }}</span>
                    <span>{{ d }}</span>
                  </div>
                </template>
              </div>
              <div class="text_left recruit_info">
                <div class="info_head" style="margin-top: 30px">职位需求：</div>
                <template v-for="(d, i) in drawers.info.wr">
                  <div :key="i">
                    <span>{{ (++i) + '、' }}</span>
                    <span>{{ d }}</span>
                  </div>
                </template>
              </div>

              <div class="send text_left recruit_info">
                <el-button type="primary" @click="dialogVisible = true">投递简历</el-button>
              </div>

              <div>
                <el-dialog :visible.sync="dialogVisible" :modal="false" width="30%">
                  <div>
                    <div><i class="el-icon-message" style="font-size: 72px" /></div>
                    <div class="dialog_font">
                      <p>请将简历及作品发送至：{{ recruitMail }}</p>
                      <p>邮件主题为：地点+职位+姓名</p>
                    </div>
                  </div>
                  <span>
                    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                  </span>
                </el-dialog>
              </div>
            </el-drawer>
          </div>
        </div>

        <!-- 显示手机招聘页面-->
        <phone-recruit />
      </div>
    </div>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css'
import { get_recruit_data_page, get_recruit_info } from '@/api/recruit'
import vv from '@/components/varVariable'
import PhoneRecruit from '@/components/phoneRecruit/phoneRecruit'

const all = '全部'
export default {
  name: 'Recruit',
  components: { PhoneRecruit },
  data() {
    return {
      addr: [],
      type: [],
      select: {
        id: '',
        like: '',
        addr: '',
        type: '',
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pages: 1
      },
      page: {
        pageSize: 10,
        pageNum: 1,
        pages: 1,
        total: 1,
        loading: false
      },
      tableData: [],
      scrollNum: 0,
      drawers: {
        drawer: false,
        d: 'rtl',
        m: false,
        info: {},
        phone: {
          drawer: false,
          d: 'rtl'
        }
      },
      dialogVisible: false,
      recruitMail: '8888888888@qq.com',
      count: 5,
      loading: false
    }
  },
  computed: {
    filePath() {
      return vv.fileHttp
    },
    noMore() {
      return this.count >= 20
    },
    disabled() {
      return this.loading || this.noMore
    }
  },
  created() {
    this.select_recruit()

    get_recruit_info()
      .then(d => {
        if (!d) {
          return
        }
        const da = d.a
        if (d.a) {
          const l = da.length
          this.addr.length = l
          for (let i = 0; i < l; i++) {
            this.addr.splice(i, 1, da[i])
          }
          this.addr.splice(0, 0, all)
        }

        const dt = d.t
        if (dt) {
          const lt = dt.length
          this.type.length = lt
          for (let i = 0; i < lt; i++) {
            this.type.splice(i, 1, dt[i])
          }
          this.type.splice(0, 0, all)
        }

        this.recruitMail = d.e
      })
  },
  mounted() {
    this.handleScroll()
  },
  methods: {
    select_recruit() {
      get_recruit_data_page(this.select)
        .then(d => {
          const data = d.d
          if (data) {
            const l = data.length
            this.tableData.length = l
            for (let i = 0; i < l; i++) {
              this.tableData.splice(i, 1, data[i])
            }
            this.select.pages = d.totalPage
            this.select.total = d.totalNum
            this.select.pageSize = d.pageSize
            this.select.pageNum = d.pageNum
          }
        })
    },
    get_addr_class(a, i) {
      const tags = this.$refs.addr_tag
      this.tags_deal(tags, i)
      this.select.addr = a === all ? '' : a
      this.select_recruit()
    },
    get_type_class(t, i) {
      const tags = this.$refs.type_tag
      this.tags_deal(tags, i)
      this.select.type = t === all ? '' : t
      this.select_recruit()
    },
    tags_deal(tags, i) {
      for (let n = 0, tag; n < tags.length; n++) {
        tag = tags[n]
        tag.className = n === i ? 'tag selected' : 'tag'
      }
    },
    show(row) {
      this.drawers.drawer = true
      this.drawers.info = row
    },
    handleScroll() {
      /* 滚动条处理*/
      const scrollbarEl = this.$refs.scrollbar.wrap
      scrollbarEl.onscroll = () => {
        const scrollTop = scrollbarEl.scrollTop
        const b = scrollTop >= 180 && scrollTop <= 240
        if (b && this.scrollNum <= 1) {
          scrollbarEl.scrollTop = 200
          this.scrollNum += 1
        } else {
          this.scrollNum = b ? this.scrollNum : 0
        }
      }
    },
    open_select() {
      this.drawers.phone.drawer = true
    },
    get_phone_addr_class(a, i) {
      const addrs = this.$refs.phone_addr
      this.tags_deal(addrs, i)
      this.select.addr = a === all ? '' : a
      this.select_recruit()
    },
    get_phone_type_class(a, i) {
      const types = this.$refs.phone_type
      this.tags_deal(types, i)
      this.select.type = a === all ? '' : a
      this.select_recruit()
    },
    change_show(i) {
      const es = this.$refs.list_li_icon
      const e = es[i]

      const infos = this.$refs.list_li_info
      const info = infos[i]
      const className = e.className
      if (className === 'el-icon-plus') {
        e.className = 'el-icon-minus'
        info.className = 'list_li_info phone_text active'
      } else {
        e.className = 'el-icon-plus'
        info.className = 'list_li_info phone_text'
      }
    },
    load() {
      this.loading = true
      this.count += 2
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
.recruit{
  min-height: 100vh;

  .index_pc_head{
    background: rgba(0, 0, 0, .7)!important;
  }

  .big_screen{
    height: auto;
    overflow-x: hidden;
    align-items: center;
    justify-content: center;

    .main{
      width: 70%;
      min-height: calc(100vh - 25rem);
      padding-top: 25px;
      position: relative;
      margin: 0 auto;

      .table{
        display: contents;
        .table_head{
          padding: 20px 30px;
          border: 1px solid #ccc;
          border-radius: 5px 5px 0 0 ;

          div{
            height: 50px;
            display: flex;
            align-items: center;
          }
          .select{
            .select_input{
              width: 30%;
              min-width: 200PX;
              margin-left: 10px;
              margin-right: 20px;
            }
            .select_button{
              //height: 18px;

              span{
                font-size: 13px;
              }
            }
          }

          .head_title{
            margin-right: 10px;
            min-width: 95PX;
          }
          .tag, .selected{
            padding: 10px;
            margin: 10px;
            transition: all .5s ease-in-out;
          }
          .tag:hover, .selected{
            background-color: #CCCCCC;
            border-radius: 6px;
            cursor: pointer;
            color: #FFFFFF;
            transition: all .5s ease-in-out;
          }
        }

        .table_main{
          margin-top: 50px;
          margin-bottom: 80px;

          .recruit_pagination{
            margin-top: 30px;
            text-align: center;
          }
        }
      }

      .drawer_title{
        font-size: 20px;
        font-style: normal;

        .recruit_info{
          margin: 0 30px;
          line-height: 27px;
          font-size: 15px;

          .info_head{
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 10px;
          }
        }

        .send{
          margin-top: 20px;
          font-size: 15px;
        }

        .dialog_font{
          font-size: 18px;
        }
      }
    }

    .join_us{
      width: 100vw;
      background-color: #f0f0f0;
    }

    .photo_wall{
      width: 100vw;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      background-color: #f0f0f0;

      .photo_wall_title{
        width: 100vw;
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        margin: 10px 0 30px 0;
        color: rgba(64, 64, 64, .9);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .photo_wall_images{
        width: 50%;
        min-width: 768PX;
        display: flex;
        justify-content: space-between;
        margin-bottom: 50px;
      }
    }
  }

  .tag{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
